export default class LightOakList {
    constructor() {
        this.number = 7;
        this.label = 'Eg plakatliste';
        this.image_name = 'light-oak-list';
        this.id = 'frame-' + this.image_name;
        this.path = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/';
        this.extension = '.png';
        this.src =  this.path + this.image_name + this.extension;
        this.paperOuterPadding = 0;
        this.addFrameShadow = false;
        this.frameCount = 1;
    }
}
